import { Service } from 'vue-di-container';

@Service()
export default class LoaderService {
  public showLoader(): void {
    window.ShowLoader();
  }
  public hideLoader(): void {
    window.HideLoader();
  }
}
